import { useState, useRef, useEffect, useCallback } from "react";
import { useForm, Controller } from "react-hook-form";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { ColorPicker } from "primereact/colorpicker";
import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Checkbox } from "primereact/checkbox";
import MenuSite from "../../ComponentsSite/NavbarSite";
import HeaderSite from "../../ComponentsSite/HeaderSite";
import GaleriaSite from "../../ComponentsSite/GaleriaSite";
import AboutSite from "../../ComponentsSite/AboutSite";
import StatusObraSite from "../../ComponentsSite/StatusWorkSite";
import FormSite from "../../ComponentsSite/FormSite";
import LocSite from "../../ComponentsSite/LocSite";
import FooterSite from "../../ComponentsSite/FooterSite";
import MapSite from "../../ComponentsSite/MapSite";
import { useWebsite } from "../../Context/WebSiteContext";

import { Tooltip } from "primereact/tooltip";
import { InputText } from "primereact/inputtext";
import { api } from "../../../../../../utils/api";
import { getUserId } from "../../../../../../utils/auth";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import UserPaymentMethods from "../../../../../../components/payment/UserPaymentMethods";
import { useTemplateContext } from "../Context/TemplateContext";
import { getUserCreditCard } from "../../../../../../services/ClientArea/getUserCreditCard";
import { toast } from "react-toastify";
import { h } from "@fullcalendar/core/preact.js";
import { formatCurrency } from "../../../../../../utils/formatCurrency";
import { Dialog } from "primereact/dialog";
import { getValidateCupom } from "../../../../../../services/CreateAccount/getValidateCupom";
import { useQuery } from "react-query";
import { getPublicMapLink } from "../../../../../../services/GlobalRoles/getPublicMapLink";

const SidebarConfig = ({ templateConfig, enterprise_id }) => {
  const {
    formData,
    setFullFormData,
    setShowBanner,
    templateId,
    updateFormData,
    setFormData,
  } = useWebsite();
  const form = useForm();
  const navigate = useNavigate();
  const { id } = useParams();
  const [paymentStep, setPaymentStep] = useState(1);
  const [cupom, setCupom] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingCupom, setLoadingCupom] = useState(false);
  const [discountValue, setDiscountValue] = useState(0);
  const [logo, setLogo] = useState(null);
  const [appliedCoupon, setAppliedCoupon] = useState(false);
  const [errorCupom, setErrorCupom] = useState(false);
  const protocol = window.location.protocol;
  const baseUrl = window.location.host;

  const [typeInterval, setTypeInterval] = useState(1);
  const descontoAplicado = appliedCoupon ? discountValue || 0 : 0;
  const { state } = useLocation();
  const monthlyValue = state?.monthly_value;
  const subscriptionValue = state?.subscription_value;
  const descontoAdesao =
    appliedCoupon?.subscription_fee_discount_rate && subscriptionValue
      ? subscriptionValue * appliedCoupon.subscription_fee_discount_rate
      : 0;
  const descontoMensal =
    appliedCoupon?.payments_discount_rate > 0 &&
    monthlyValue &&
    appliedCoupon.affected_payments > 0
      ? monthlyValue * appliedCoupon.payments_discount_rate
      : 0;
  const totalComDesconto =
    (subscriptionValue || 0) -
    descontoAdesao +
    (monthlyValue || 0) -
    descontoMensal;
  const totalSemDesconto = subscriptionValue || 0;
  // const totalComDesconto = totalSemDesconto - descontoAplicado + monthlyValue;
  const templateNameRaw = state?.name;
  const landingPageTemplateId = state?.landing_page_template_id;
  let templateName = templateNameRaw;
  if (templateNameRaw === "Template 1") templateName = "Template Classic";
  if (templateNameRaw === "Template 2") templateName = "Template Modern";
  if (templateNameRaw === "Template 3") templateName = "Template Minimalist";

  const {
    control,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState,
    trigger,
    getValues,
  } = useForm({
    defaultValues: formData,
    shouldUnregister: false,
  });

  // Atualiza o contexto formData ao vivo apenas quando orderedSections ou sections mudam
  useEffect(() => {
    setFormData(getValues());
  }, [watch("orderedSections"), watch("sections")]);
  const {
    cards,
    visible,
    setCards,
    cardState,
    pixClient,
    pixDataQR,
    setVisible,
    setPixDataQR,
    handleSubmitPayment,
    baseDataForm,
    paymentMethod,
    loadingButton,
    activeIndexModal,
    handleInputFocus,
    setPaymentMethod,
    creditCardClient,
    visiblePixPayment,
    handleInputChange,
    optionsInstallments,
    setActiveIndexModal,
    setCreditCardClient,
    setVisiblePixPayment,
    visiblePaymentMethods,
    visibleModalCreditCard,
    setVisiblePaymentMethods,
    setVisibleModalCreditCard,
  } = useTemplateContext();

  const defaultValues = {
    logo: "",
    colornav: "#ffffff",
    colornavtext: "#000000",
    sections: {
      Menu: true,
      Cabeçalho: true,
      Galeria: true,
      Sobre: true,
      Map: true,
      Status: true,
      Loc: true,
      Formulario: true,
      Rodapé: true,
    },
    orderedSections: [
      "Menu",
      "Cabeçalho",
      "Galeria",
      "Sobre",
      "Map",
      "Status",
      "Loc",
      "Formulario",
      "Rodapé",
    ],
    ...templateConfig,
  };

  const [isLoading, setIsLoading] = useState(false);
  const [disabledButton, setDisabledButton] = useState(true);

  useEffect(() => {
    const fetchCards = async () => {
      setIsLoading(true);
      try {
        const data = await getUserCreditCard();
        setIsLoading(false);
        setCards(data);
      } catch (error) {
        toast.error("Houve um erro ao buscar os cartões cadastrados");
      }
    };
    fetchCards();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data: linkMap, isError } = useQuery(
    ["mapLink", enterprise_id], // chave única para cache
    async () => {
      const sendData = {
        empId: enterprise_id,
        typeMap: "map",
      };
      const res = await getPublicMapLink(sendData);
      return `${protocol}//${baseUrl}/publicMap/${res.success}`;
    },
    {
      enabled: !!enterprise_id, // só executa se tiver enterprise_id
    }
  );

  useEffect(() => {
    const testDisabledButton = () => {
      const isCardStateEmpty = Object.values(cardState).some(
        (value) => value === ""
      );

      if (paymentMethod === "pix") {
        setDisabledButton(false);
        return;
      }

      if (
        (isCardStateEmpty || paymentMethod === null) &&
        cards.every((card) => card.active === 0)
      ) {
        setDisabledButton(true);
      } else {
        setDisabledButton(false);
      }
    };
    testDisabledButton();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardState, pixClient, paymentMethod, cards, visiblePaymentMethods]);

  const handleSelectCard = async (card) => {
    // console.log(card);
    const updatedData = [...cards];
    const index = updatedData.findIndex((c) => c.id === card.id);
    const indexActive = updatedData.findIndex((c) => c.active === 1);
    if (indexActive !== -1) {
      updatedData[indexActive].active = 0;
    }
    if (index !== -1) {
      updatedData[index].active = 1;
    }
    setCards(updatedData);
    setPaymentMethod(null);
  };

  const handleSelectPaymentMethod = (value) => {
    const updatedData = [...cards];
    const indexActive = updatedData.findIndex((c) => c.active === 1);
    if (indexActive !== -1) {
      updatedData[indexActive].active = 0;
    }
    setCards(updatedData);
    if (value === "card") {
      setVisiblePaymentMethods(false);
    }
    setPaymentMethod(value);
  };

  const handleColorChange = useCallback(
    (field, value) => {
      setFormData((prev) => ({
        ...prev,
        primaryColor: value.replace(/^#/, ""),
      }));
      setValue(`${field}`, value, { shouldDirty: true });
      console.log(`Cor do ${field} alterada para:`, value);
    },
    [updateFormData, setValue]
  );

  const optionsnavbar = templateConfig?.optionsnavbar || [
    { name: "Inicio", value: "Home" },
    { name: "Sobre", value: "About" },
    { name: "Galeria", value: "Gallery" },
    { name: "Contato", value: "Contact" },
  ];

  const [sidebarVisible, setSidebarVisible] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [activeAccordionIndex, setActiveAccordionIndex] = useState(null);
  const [logoError, setLogoError] = useState("");
  const [publishLoading, setPublishLoading] = useState(false);
  const [publishMessage, setPublishMessage] = useState("");
  const [paymentConfirmed, setPaymentConfirmed] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileUpload = async (e) => {
    setLogoError("");
    let file;
    if (e?.target?.files) {
      file = e.target.files[0];
    } else if (e?.files) {
      file = e.files[0];
    }
    if (!file) return;

    if (file.size > 50 * 1024 * 1024) {
      setLogoError("O arquivo deve ter no máximo 50MB.");
      return;
    }

    const img = new window.Image();
    const objectUrl = URL.createObjectURL(file);
    img.onload = async () => {
      const minWidth = 40,
        minHeight = 40,
        maxWidth = 500,
        maxHeight = 500;
      if (
        img.width < minWidth ||
        img.height < minHeight ||
        img.width > maxWidth ||
        img.height > maxHeight
      ) {
        setLogoError(
          `A imagem deve ter entre ${minWidth}x${minHeight}px e ${maxWidth}x${maxHeight}px.`
        );
        URL.revokeObjectURL(objectUrl);
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        setValue("logo", reader.result, { shouldDirty: true });
        setLogo(reader.result);
        setFormData({ ...getValues(), logo: reader.result });
      };
      reader.onerror = () => {
        setLogoError("Erro ao ler o arquivo.");
      };
      reader.readAsDataURL(file);
      URL.revokeObjectURL(objectUrl);
    };
    img.onerror = () => {
      setLogoError("Arquivo de imagem inválido.");
      URL.revokeObjectURL(objectUrl);
    };
    img.src = objectUrl;
  };

  const onDragEnd = (result) => {
    if (!result.destination || activeAccordionIndex !== null) return;

    const currentOrder = watch("orderedSections") || [];
    const newOrder = Array.from(currentOrder);
    const [movedItem] = newOrder.splice(result.source.index, 1);
    newOrder.splice(result.destination.index, 0, movedItem);

    setValue("orderedSections", newOrder, { shouldDirty: true });
    trigger();
  };

  const toggleSection = (section) => {
    const currentSections = watch("sections") || {};
    const newValue = !currentSections[section];

    setValue(
      "sections",
      { ...currentSections, [section]: newValue },
      { shouldDirty: true }
    );
    const currentOrder = watch("orderedSections") || [];

    if (!currentOrder.includes(section)) {
      setValue("orderedSections", [...currentOrder, section], {
        shouldDirty: true,
      });
    }
  };

  // const validateCupom = (code) => {
  //   const total = subscriptionValue || 0;

  //   if (code === "DESCONTO10") {
  //     setAppliedCoupon(true);
  //     const desconto = total * 0.1; // 10% de desconto
  //     setDiscountValue(desconto);
  //   } else {
  //     setAppliedCoupon(false);
  //     setDiscountValue(0);
  //   }
  // };

  const validateCupom = async (cupom) => {
    console.log(cupom);
    console.log(typeInterval);

    setLoading(true);
    // const notification = toast.loading("Por favor aguarde...");
    try {
      const response = await getValidateCupom(cupom, typeInterval);
      if (response.cupom !== false) {
        setAppliedCoupon(response.cupom);
        form.clearErrors("cupom");
        setErrorCupom(false);
      } else {
        form.setError("cupom");
        setErrorCupom(true);
      }
    } catch (e) {
      form.setError("cupom");
      setErrorCupom(true);
    }
    setLoading(false);
  };

  const handleOpenSidebar = () => {
    setSidebarVisible(true);

    const allSections = defaultValues.orderedSections;
    let orderedSections =
      formData.orderedSections ||
      formData.orderedsections ||
      defaultValues.orderedSections;
    if (!orderedSections) orderedSections = [...allSections];
    orderedSections = Array.from(new Set([...orderedSections, ...allSections]));

    let sections = { ...defaultValues.sections, ...(formData.sections || {}) };
    allSections.forEach((section) => {
      if (typeof sections[section] === "undefined") {
        sections[section] = true;
      }
    });

    reset({
      ...defaultValues,
      ...formData,
      orderedSections,
      sections,
    });
  };

  // Função para publicar configurações
  const handlePublish = async (data) => {
    setPublishLoading(true);
    setPublishMessage("");
    const normalizeColor = (color, fallback) => {
      if (!color) return fallback;
      if (typeof color === "string") return color.replace(/^#/, "");
      return fallback;
    };
    const newFormData = {
      ...formData,
      logo: data.logo || formData.logo || logo,
      enterprise_id: state?.enterprise_id || formData?.enterprise_id,
      primaryColor: normalizeColor(
        data.primaryColor || formData.primaryColor,
        "ffffff"
      ),
      secondaryColor: normalizeColor(
        data.secondaryColor || formData.secondaryColor,
        "ffffff"
      ),
      sections: {
        Menu: data.sections.Menu,
        Cabeçalho: data.sections["Cabeçalho"],
        Galeria: data.sections.Galeria,
        Sobre: data.sections.Sobre,
        Map: data.sections.Map,
        Status: data.sections.Status,
        Loc: data.sections.Loc,
        Formulario: data.sections.Formulario,
        Rodapé: data.sections["Rodapé"],
      },
      orderedSections: data.orderedSections,
      navbar: {
        ...(formData.navbar || {}),
        ...(data.navbar || {}),
        colornav: normalizeColor(
          data.navbar?.colornav || formData.navbar?.colornav,
          "ffffff"
        ),
        colornavtext: normalizeColor(
          data.navbar?.colornavtext || formData.navbar?.colornavtext,
          "000000"
        ),
      },
      header: {
        ...(formData.header || {}),
        ...(data.header || {}),
        primaryColor: normalizeColor(
          data.primaryColor || formData.primaryColor,
          "ffffff"
        ),
        secondaryColor: normalizeColor(
          data.secondaryColor || formData.secondaryColor,
          "ffffff"
        ),
      },
      map: linkMap || data.map || formData.map,
      galeria: data.galeria || formData.galeria,
      statusObra: data.statusObra || formData.statusObra,
      formulario: data.formulario || formData.formulario,
      sobreNos: data.sobreNos || formData.sobreNos,
      footer: {
        ...(data.footer || formData.footer),
        textColorFooter: normalizeColor(
          data.footer?.textColorFooter || formData.footer?.textColorFooter,
          "000000"
        ),
      },
      loc: data.loc || formData.loc,
    };
    try {
      const token = localStorage.getItem("@walletLoteToken");
      if (!token) {
        setPublishMessage("Você não está autenticado. Faça login novamente.");
        setPublishLoading(false);
        return;
      }
      const url = formData?.url || window.location.hostname;
      const domain = formData?.domain || "";
      const enterprise_id = state?.enterprise_id || formData?.enterprise_id;
      const landing_page_template_id = state?.landing_page_template_id;
      const templateName =
        templateConfig?.name || templateConfig?.route || templateId;
      const payload = {
        template_id: landing_page_template_id,
        page: JSON.stringify(newFormData),
        enterprise_id: parseInt(enterprise_id),
      };

      await api.post("/landingPage/config", payload);
      setPublishMessage("Publicado com sucesso!");
      setShowBanner(false);
      // window.location.reload();
    } catch (err) {
      if (err.response && err.response.status === 401) {
        setPublishMessage("Não autorizado. Faça login novamente.");
      } else {
        setPublishMessage("Erro ao publicar. Tente novamente.");
      }
    } finally {
      setPublishLoading(false);
    }
  };

  // const handleSalvarConfiguracoes = () => {
  //   navigate(`/template/${id}`);
  // };

  return (
    <>
      <Button
        icon="pi pi-cog"
        className="p-button-suucess p-button-rounded"
        style={{
          position: "fixed",
          right: "10px",
          bottom: "10px",
          zIndex: 1000,
          borderRadius: "500px",
        }}
        onClick={handleOpenSidebar}
      />
      
      <Sidebar
        ClassName=""
        visible={sidebarVisible}
        onHide={() => setSidebarVisible(false)}
        position="right"
        className="p-2"
        blockScroll
        style={{
          zIndex: 9999,
          width: "100vw",
          maxWidth: "420px",
        }}
        header={
          <div className="d-flex justify-content-between align-items-center"></div>
        }
      >
        <form className="h-100 w-100">
          <div className="d-flex flex-column h-100 w-100">
            <div className="mb-4"></div>

            <div className="flex-grow-1 overflow-auto">
              <div className="row mb-4 g-2">
                <div className="col-12 col-md-4 mb-3">
                  <Controller
                    name="logo"
                    control={control}
                    defaultValue={formData.logo || ""}
                    render={({ field }) => (
                      <div className="text-center">
                        <input
                          type="file"
                          accept="image/*"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          onChange={handleFileUpload}
                        />
                        <Button
                          type="button"
                          label="Logo"
                          icon="pi pi-upload"
                          className="p-button-outlined "
                          onClick={() =>
                            fileInputRef.current && fileInputRef.current.click()
                          }
                          tooltip="Clique para fazer upload da logo"
                        />
                        <div>
                          <span
                            className="text-muted "
                            style={{ fontSize: "0.7rem" }}
                          >
                            O arquivo precisa de ter no maximo até 50MB
                          </span>
                        </div>
                        {field.value && (
                          <div className="mt-2 d-flex justify-content-center">
                            <img
                              src={field.value}
                              alt="Logo Preview"
                              style={{
                                maxWidth: 100,
                                maxHeight: 100,
                                borderRadius: 8,
                                border: "1px solid #eee",
                              }}
                            />
                          </div>
                        )}
                        {logoError && (
                          <div className="text-danger small mt-2">
                            {logoError}
                          </div>
                        )}
                      </div>
                    )}
                  />
                </div>

                <div className="col-12 col-md-4 mb-3">
                  <label
                    className="w-100 text-center color-tooltip mb-2"
                    data-pr-tooltip="Cor dos títulos e dos fundos de botões"
                    data-pr-position="top"
                  >
                    Cor Principal
                  </label>
                  <Tooltip
                    target=".color-tooltip"
                    content="Cor Principal"
                    position="top"
                  />

                  <Controller
                    name="primaryColor"
                    control={control}
                    defaultValue={formData.primaryColor || "#0d1b2a"}
                    render={({ field }) => (
                      <div className="d-flex flex-row align-items-center justify-content-center gap-2">
                        <ColorPicker
                          value={field.value?.replace("#", "")}
                          onChange={(e) => {
                            const hex = "#" + e.value;
                            field.onChange(hex);
                            handleColorChange("primaryColor", hex);
                          }}
                          format="hex"
                        />
                        <InputText
                          value={field.value}
                          onChange={(e) => {
                            field.onChange(e.target.value);
                            handleColorChange("primaryColor", e.target.value);
                          }}
                          placeholder="#FFFFFF"
                          className="w-50 text-center"
                        />
                      </div>
                    )}
                  />
                </div>

                <div className="col-12 col-md-4 mb-3">
                  <label className="w-100 text-center mb-2">
                    Cor Secundária
                  </label>
                  <Controller
                    name="secondaryColor"
                    control={control}
                    render={({ field }) => (
                      <div className="d-flex flex-row align-items-center justify-content-center gap-2">
                        <ColorPicker
                          value={field.value?.replace("#", "")}
                          onChange={(e) => field.onChange("#" + e.value)}
                          format="hex"
                        />
                        <InputText
                          value={field.value}
                          onChange={(e) => field.onChange(e.target.value)}
                          placeholder="#FFFFFF"
                          className="w-50 text-center"
                        />
                      </div>
                    )}
                  />
                </div>

                <span className="text-center mt-3 text-muted">
                  Arraste para alterar a ordem no site
                </span>
              </div>

              {/* Seções Arrastáveis */}
              <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="sections">
                  {(provided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                      {(watch("orderedSections") || []).map(
                        (section, index) => (
                          <Draggable
                            key={section}
                            draggableId={section}
                            index={index}
                            isDragDisabled={activeAccordionIndex !== null}
                          >
                            {(provided) => (
                              <div
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                className="mb-2"
                              >
                                <Accordion
                                  activeIndex={
                                    activeAccordionIndex === index ? 0 : null
                                  }
                                  onTabChange={(e) =>
                                    setActiveAccordionIndex(
                                      e.index === 0 ? index : null
                                    )
                                  }
                                >
                                  <AccordionTab
                                    header={
                                      <div className="d-flex align-items-center justify-content-between">
                                        <div
                                          {...provided.dragHandleProps}
                                          style={{ cursor: "grab" }}
                                          className="ms-2"
                                        >
                                          <span>:::</span>
                                        </div>
                                        <span
                                          className={
                                            watch("sections")?.[section]
                                              ? ""
                                              : "text-decoration-line-through"
                                          }
                                          style={{
                                            flex: 1,
                                            textAlign: "center",
                                          }}
                                        >
                                          {section}
                                        </span>
                                        <Checkbox
                                          checked={
                                            watch("sections")?.[section] ||
                                            false
                                          }
                                          onChange={(e) => {
                                            e.stopPropagation();
                                            toggleSection(section);
                                          }}
                                        />
                                      </div>
                                    }
                                  >
                                    {section === "Menu" && (
                                      <MenuSite
                                        control={control}
                                        setValue={(name, value, options) => {
                                          setValue(name, value, {
                                            shouldDirty: true,
                                            ...(options || {}),
                                          });
                                          if (name.startsWith("navbar")) {
                                            trigger();
                                          }
                                        }}
                                        form={form}
                                        config={templateConfig}
                                        watch={watch}
                                      />
                                    )}
                                    {section === "Cabeçalho" && (
                                      <HeaderSite
                                        control={control}
                                        setValue={setValue}
                                        templateId={templateId}
                                      />
                                    )}

                                    {section === "Galeria" && (
                                      <GaleriaSite
                                        form={form}
                                        control={control}
                                        setValue={(name, value) =>
                                          setValue(name, value, {
                                            shouldDirty: true,
                                          })
                                        }
                                      />
                                    )}
                                    {section === "Sobre" && (
                                      <AboutSite
                                        control={control}
                                        setValue={setValue}
                                      />
                                    )}
                                    {section === "Map" && (
                                      <MapSite
                                        control={control}
                                        form={form}
                                        setValue={setValue}
                                        errors={form.formState?.errors}
                                        templateId={templateId}
                                        enterprise_id={enterprise_id}
                                        config={templateConfig} // se o componente espera 'config'
                                      />
                                    )}
                                    {section === "Status" && (
                                      <StatusObraSite
                                        control={control}
                                        setValue={setValue}
                                        watch={watch}
                                      />
                                    )}

                                    {section === "Formulario" && (
                                      <FormSite
                                        form={form}
                                        control={control}
                                        setValue={setValue}
                                        config={templateConfig}
                                      />
                                    )}
                                    {section === "Loc" && (
                                      <LocSite
                                        control={control}
                                        setValue={setValue}
                                        config={templateConfig}
                                      />
                                    )}
                                    {section === "Rodapé" && (
                                      <FooterSite
                                        control={control}
                                        setValue={setValue}
                                        getValues={getValues}
                                      />
                                    )}
                                  </AccordionTab>
                                </Accordion>
                              </div>
                            )}
                          </Draggable>
                        )
                      )}
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </div>

            <div className="mt-4 pt-3 border-top w-100">
              <Button
                type="button"
                label="Salvar Configurações"
                icon="pi pi-check"
                className="w-100 mb-2"
                onClick={handleSubmit(async (data) => {
                  await handlePublish(data);
                })}
                disabled={publishLoading}
              />
              {publishMessage && (
                <div
                  className={`mt-2 text-center ${
                    publishMessage.includes("sucesso")
                      ? "text-success"
                      : "text-danger"
                  }`}
                >
                  {publishMessage}
                </div>
              )}
            </div>
          </div>
        </form>
      </Sidebar>
      {showPayment && !paymentConfirmed && (
        <Dialog
          visible={showPayment}
          onHide={() => setShowPayment(false)}
          header={`Módulo - ${templateName}`}
          style={{ width: "90vw", maxWidth: "500px" }}
          modal
          dismissableMask
        >
          {/* VARIÁVEIS DE CÁLCULO */}
          {(() => {
            var totalSemDesconto = subscriptionValue || 0;
            var descontoAplicado = appliedCoupon ? discountValue || 0 : 0;
            var totalComDesconto = totalSemDesconto - descontoAplicado;
            return null;
          })()}

          {/* ETAPA 1 – VALORES E CUPOM */}
          {paymentStep === 1 && (
            <>
              <div
                className="flex flex-column gap-2 mb-3"
                style={{ fontFamily: "Axiforma, sans-serif" }}
              >
                {subscriptionValue && (
                  <div
                    className="d-flex justify-content-between align-items-center px-3 py-2 border-round"
                    style={{ backgroundColor: "#F8F8F8" }}
                  >
                    <span
                      style={{
                        fontWeight: 600,
                        fontSize: 14,
                        color: "#686868",
                      }}
                    >
                      Adesão
                    </span>
                    <span style={{ fontWeight: 700, fontSize: 16 }}>
                      {formatCurrency(subscriptionValue)}
                    </span>
                  </div>
                )}

                {monthlyValue && (
                  <div
                    className="d-flex justify-content-between align-items-center px-3 py-2 border-round"
                    style={{ backgroundColor: "#FFFFFF" }}
                  >
                    <span
                      style={{
                        fontWeight: 600,
                        fontSize: 14,
                        color: "#686868",
                      }}
                    >
                      Mensalidade
                    </span>
                    <span style={{ fontWeight: 700, fontSize: 16 }}>
                      {formatCurrency(monthlyValue)}
                    </span>
                  </div>
                )}
              </div>

              {/* Cupom */}
              <div className="d-flex flex-row justify-content-between mb-3">
                <InputText
                  name="cupom"
                  value={cupom}
                  onChange={(e) => setCupom(e.target.value)}
                  placeholder="Cupom de Desconto"
                  className="col-md-8"
                  style={{ height: "36px", fontSize: 14 }}
                />
                <Button
                  disabled={cupom.length === 0}
                  label="Aplicar"
                  className="col-md-3"
                  onClick={() => validateCupom(cupom)}
                  style={{ height: "36px", fontSize: 14 }}
                />
              </div>

              {/* Cupom ativo */}
              {appliedCoupon && (
                <div
                  className="px-3 py-2 border-round text-center mb-2"
                  style={{
                    border: "1px solid #14B8A6",
                    color: "#14B8A6",
                    fontWeight: "bold",
                    fontSize: 13,
                    maxWidth: "100%",
                    margin: "0 auto",
                  }}
                >
                  "{cupom}" Ativo
                </div>
              )}

              {/* Totais e desconto */}
              {/* Descontos aplicados */}
              {(descontoAdesao > 0 || descontoMensal > 0) && (
                <>
                  {descontoAdesao > 0 && (
                    <div
                      className="d-flex justify-content-between align-items-center px-3 py-2 border-round mb-2"
                      style={{ backgroundColor: "#E8F5E9" }}
                    >
                      <span
                        style={{
                          fontWeight: 600,
                          fontSize: 14,
                          color: "#388E3C",
                        }}
                      >
                        Desconto aplicado (adesão)
                      </span>
                      <span
                        style={{
                          fontWeight: 700,
                          fontSize: 16,
                          color: "#388E3C",
                        }}
                      >
                        - {formatCurrency(descontoAdesao)}
                      </span>
                    </div>
                  )}
                  {descontoMensal > 0 && (
                    <div
                      className="d-flex justify-content-between align-items-center px-3 py-2 border-round mb-2"
                      style={{ backgroundColor: "#E8F5E9" }}
                    >
                      <span
                        className="w-75"
                        style={{
                          fontWeight: 600,
                          fontSize: 14,
                          color: "#388E3C",
                        }}
                      >
                        Desconto aplicado (mensalidade)
                        {appliedCoupon?.affected_payments > 1 &&
                          ` - nas ${appliedCoupon.affected_payments} primeiras parcelas`}
                        {appliedCoupon?.affected_payments === 1 &&
                          ` - na primeira parcela`}
                      </span>
                      <span
                        style={{
                          fontWeight: 700,
                          fontSize: 16,
                          color: "#388E3C",
                        }}
                      >
                        - {formatCurrency(descontoMensal)}
                      </span>
                    </div>
                  )}
                </>
              )}

              {/* Total final */}
              <div
                className="d-flex justify-content-between align-items-center px-3 py-2 border-round"
                style={{ backgroundColor: "#f5f5f5" }}
              >
                <span
                  style={{ fontWeight: 600, fontSize: 14, color: "#282829" }}
                >
                  Total
                </span>
                <span
                  style={{ fontWeight: 700, fontSize: 16, color: "#282829" }}
                >
                  {formatCurrency(totalComDesconto)}
                </span>
              </div>

              <div className="w-100 d-flex align-items-center justify-content-center">
                <Button
                  label="Prosseguir para Pagamento"
                  className="w-100 mt-3 fs-5 text-center"
                  style={{ minWidth: "180px" }}
                  onClick={() => setPaymentStep(2)}
                />
              </div>
            </>
          )}

          {/* ETAPA 2 – MÉTODO DE PAGAMENTO */}
          {paymentStep === 2 && (
            <>
              <div className="flex flex-column gap-2 mb-3">
                {subscriptionValue && (
                  <div
                    className="d-flex justify-content-between text-color-secondary mb-2"
                    style={{ fontSize: 13 }}
                  >
                    <span>Adesão:</span>
                    <span>{formatCurrency(subscriptionValue)}</span>
                  </div>
                )}

                {monthlyValue && (
                  <div
                    className="d-flex justify-content-between text-color-secondary mb-2"
                    style={{ fontSize: 13 }}
                  >
                    <span>Mensalidade:</span>
                    <span>{formatCurrency(monthlyValue)}</span>
                  </div>
                )}

                {appliedCoupon && (
                  <>
                    <div
                      className="d-flex justify-content-between mb-2"
                      style={{ fontSize: 13, color: "#14B8A6" }}
                    >
                      <span>Cupom aplicado:</span>
                      <span>{cupom}</span>
                    </div>

                    {/* Desconto na adesão */}
                    {descontoAdesao > 0 && (
                      <div
                        className="d-flex justify-content-between mb-2"
                        style={{ fontSize: 13, color: "#388E3C" }}
                      >
                        <span>Desconto (adesão):</span>
                        <span>- {formatCurrency(descontoAdesao)}</span>
                      </div>
                    )}

                    {/* Desconto na mensalidade */}
                    {descontoMensal > 0 && (
                      <div
                        className="d-flex justify-content-between mb-2"
                        style={{ fontSize: 13, color: "#388E3C" }}
                      >
                        <span>
                          Desconto (mensalidade)
                          {appliedCoupon?.affected_payments === 1 &&
                            " - na primeira parcela"}
                          {appliedCoupon?.affected_payments > 1 &&
                            ` - nas ${appliedCoupon?.affected_payments} primeiras parcelas`}
                        </span>
                        <span>- {formatCurrency(descontoMensal)}</span>
                      </div>
                    )}
                  </>
                )}

                <div
                  className="d-flex justify-content-between mb-2"
                  style={{ fontWeight: "bold", fontSize: 14 }}
                >
                  <span>Total:</span>
                  <span>{formatCurrency(totalComDesconto)}</span>
                </div>
              </div>

              {/* Métodos de pagamento */}
              <UserPaymentMethods
                pix
                card
                cards={cards}
                form={form}
                cardState={cardState}
                paymentMethod={paymentMethod}
                setPaymentMethod={setPaymentMethod}
                handleSelectCard={handleSelectCard}
                handleInputFocus={handleInputFocus}
                creditCardClient={creditCardClient}
                handleInputChange={handleInputChange}
                setActiveIndexModal={setActiveIndexModal}
                visiblePaymentMethods={visiblePaymentMethods}
                setVisiblePaymentMethods={setVisiblePaymentMethods}
                setVisibleModalCreditCard={setVisibleModalCreditCard}
                handleSelectPaymentMethod={handleSelectPaymentMethod}
              />

              {/* Botões */}
              <div className="d-flex gap-2 mt-4 justify-content-between">
                <Button
                  label="Voltar"
                  className="p-button-outlined w-6"
                  onClick={() => setPaymentStep(1)}
                />
                <Button
                  label="Confirmar Pagamento"
                  className="p-button-success w-6"
                  disabled={disabledButton}
                  onClick={() =>
                    handleSubmitPayment(
                      landingPageTemplateId,
                      appliedCoupon ? cupom : undefined
                    )
                  }
                />
              </div>
            </>
          )}
        </Dialog>
      )}
    </>
  );
};

export default SidebarConfig;
